import { forwardRef } from 'react';

import { Typography, TypographyProps } from '@mui/material';

export const DetailsListFinalItemTypography = forwardRef<
  HTMLSpanElement,
  Omit<TypographyProps, 'variant' | 'textTransform'>
>(({ children, ...rest }, ref) => (
  <Typography {...rest} variant="body1.semibold" ref={ref} textTransform="none">
    {children}
  </Typography>
));
